import React, { useState, useEffect } from 'react';
import Modal from "react-modal";
import { FaFacebook, FaInstagram, FaYoutube, FaWhatsapp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

function ContactUs() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [formSent, setFormSent] = useState(false);
  const [subject, setSubject] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { t, i18n } = useTranslation();
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    try {
      const response = await fetch('https://xianhefairy.com/LotusFairy_API/api/ContactUs/ContactUsUpdate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          Name: name,
          Email: email,
          Subject: subject,
          Message: message,
        }),
      });
      if (response.ok) {
        setFormSent(true);
        setShowModal(true);
        setName('');
        setEmail('');
        setMessage('');
        setSubject('');
      } else {
        setErrorMessage(`Failed to send message: ${response.status} ${response.statusText}`);
      }
    } catch (error) {
      setErrorMessage(`An error occurred: ${error.message}`);
    }
  };

  const closeModal = () => setShowModal(false);

  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#151517',
      padding: '2rem',
    },
    card: {
      width: '100%',
      maxWidth: '500px',
      backgroundColor: 'transparent',
      borderRadius: '12px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
      padding: '1.5rem',
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: '1rem',
      textAlign: 'center',
      color: '#DFBD69',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    },
    label: {
      fontSize: '0.9rem',
      color: '#DFBD69',
    },
    input: {
      width: '100%',
      padding: '0.8rem',
      border: '1px solid #dddddd',
      borderRadius: '8px',
      fontSize: '0.9rem',
      color: '#333333',
      outline: 'none',
    },
    textarea: {
      width: '100%',
      padding: '0.8rem',
      border: '1px solid #dddddd',
      borderRadius: '8px',
      fontSize: '0.9rem',
      color: '#333333',
      outline: 'none',
      resize: 'none',
    },
    button: {
      width: '100%',
      padding: '0.8rem',
      backgroundColor: '#DFBD69',
      color: '#151517',
      border: 'none',
      borderRadius: '8px',
      fontSize: '1rem',
      fontWeight: 'bold',
      cursor: 'pointer',
      textAlign: 'center',
      outline: 'none',
    },
    successMessage: {
      textAlign: 'center',
      color: '#28a745',
      fontSize: '1rem',
      marginTop: '1rem',
    },
    socialIcons: {
      display: 'flex',
      justifyContent: 'center',
      gap: '1rem',
      marginTop: '1rem',
    },
    icon: {
      color: '#DFBD69',
      fontSize: '1.5rem',
      cursor: 'pointer',
    },
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    },
    modalContent: {
      background: '#212121',
      padding: '2rem',
      borderRadius: '12px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
      textAlign: 'center',
      minWidth: '30%',
    },
    modalButton: {
      marginTop: '1rem',
      padding: '0.5rem 1.5rem',
      backgroundColor: '#DFBD69',
      color: '#151517',
      border: 'none',
      borderRadius: '8px',
      fontSize: '1rem',
      fontWeight: 'bold',
      cursor: 'pointer',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>{t('contactPage.contactUs')}</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div>
            <label htmlFor="name" style={styles.label}>{t('contactPage.name')}</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              style={styles.input}
            />
          </div>
          <div>
            <label htmlFor="email" style={styles.label}>{t('contactPage.email')}</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={styles.input}
            />
          </div>
          <div>
            <label htmlFor="subject" style={styles.label}>{t('contactPage.subject')}</label>
            <input
              type="text"
              id="subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
              style={styles.input}
            />
          </div>
          <div>
            <label htmlFor="message" style={styles.label}>{t('contactPage.message')}</label>
            <textarea
              id="message"
              rows="4"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              style={styles.textarea}
            ></textarea>
          </div>
          <button type="submit" style={styles.button}>{t('contactPage.send')}</button>
          {errorMessage && (
            <p style={{ color: '#e05252', fontSize: '0.9rem', textAlign: 'center', margin: 0 }}>
              {errorMessage}
            </p>
          )}
        </form>
      </div>
      <div style={styles.socialIcons}>
        <FaFacebook style={styles.icon} />
        <FaInstagram style={styles.icon} />
        <FaYoutube style={styles.icon} />
        <FaWhatsapp style={styles.icon} />
      </div>
      {showModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <p style={{ color: '#dfbd69', fontSize: '1rem' }}>
              {t('contactPage.responseMessage')}
            </p>
            <button style={styles.modalButton} onClick={closeModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ContactUs;
